import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormfieldPhoneComponent} from './formfield-phone.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

const dec_exp = [
  FormfieldPhoneComponent
];

@NgModule({
  declarations: [dec_exp],
  exports: [dec_exp],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class FormfieldPhoneModule {
}
